import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

type allModelsDto = ClientInferResponseBody<typeof contract.models.findAll>;

export const fetchAllModels = async (): Promise<allModelsDto | null> => {
  const response = await api.models.findAll.query();

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
